import { formatCentsToUsd } from '../../../helpers/formatCentsToUsd';
import { formatDateTimeInVenueTz } from '../../../helpers/formatDateTime';
import {
    centsToXlsxNumber,
    applyCurrencyFormat,
    writeWorkbookAndSave,
    buildDateRangeLabel,
    buildFilenameRange,
} from '../../../helpers/excelExportHelpers';
import { aggregateBreakdown } from './aggregateCancelledRefundedBreakdown';

export const exportAffiliateCancelledRefundedReportToXlsx = async (
    reportData,
    dateFrom,
    dateTo,
    showTicketTypeBreakdown = false,
    showTicketOptionBreakdown = false,
) => {
    const XLSX = await import('xlsx');

    const sheetData = [];

    const rangeLabel = buildDateRangeLabel(dateFrom, dateTo);

    sheetData.push(['Affiliate Cancelled/Refunded Report']);
    sheetData.push([`Date Range: ${rangeLabel}`]);
    sheetData.push([
        `Total Bookings: ${reportData.totalBookings || 0}`,
        `Total Original Amount: ${formatCentsToUsd(reportData.totalOriginalAmount || 0)}`,
        `Total Refunded Amount: ${formatCentsToUsd(reportData.totalRefundedAmount || 0)}`,
        `Total Processing Fees: ${formatCentsToUsd(reportData.totalProcessingFees || 0)}`,
    ]);
    sheetData.push([]);

    sheetData.push([
        'Booking ID',
        'Status',
        'Agent',
        'Commission Group',
        'Ticket Type',
        'Ticket Option',
        'Pax',
        'Cancelled On',
        'Cancelled By',
        'Reason',
        'Original Amount',
        'Refunded Amount',
        'Processing Fees',
    ]);

    (reportData.items || []).forEach((item) => {
        const commissionGroupName = item.commissionGroupName || '';
        const agentName = item.agentName || '';
        const cancellationDate = item.cancellationDate
            ? formatDateTimeInVenueTz(item.cancellationDate)
            : '';

        sheetData.push([
            item.bookingId,
            item.bookingStatus || '',
            agentName,
            commissionGroupName,
            '',
            '',
            '',
            cancellationDate,
            item.cancellationActor || '',
            item.cancellationReason || '',
            centsToXlsxNumber(item.originalAmount),
            centsToXlsxNumber(item.refundedAmount),
            centsToXlsxNumber(item.processingFees),
        ]);

        aggregateBreakdown(
            item.breakdown || [],
            showTicketTypeBreakdown,
            showTicketOptionBreakdown,
        ).forEach((bd) => {
            sheetData.push([
                '',
                '',
                '',
                '',
                bd.ticketTypeName || '-',
                bd.ticketOptionName || '-',
                bd.itemCount,
                '',
                '',
                '',
                centsToXlsxNumber(bd.totalAmount),
                '',
                '',
            ]);
        });
    });

    sheetData.push([
        'Grand Total',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        centsToXlsxNumber(reportData.totalOriginalAmount || 0),
        centsToXlsxNumber(reportData.totalRefundedAmount || 0),
        centsToXlsxNumber(reportData.totalProcessingFees || 0),
    ]);

    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    ws['!cols'] = [
        { wch: 12 }, // Booking ID
        { wch: 12 }, // Status
        { wch: 20 }, // Agent
        { wch: 25 }, // Commission Group
        { wch: 25 }, // Ticket Type
        { wch: 20 }, // Ticket Option
        { wch: 8 }, // Pax
        { wch: 14 }, // Cancelled On
        { wch: 18 }, // Cancelled By
        { wch: 25 }, // Reason
        { wch: 16 }, // Original Amount
        { wch: 16 }, // Refunded Amount
        { wch: 16 }, // Processing Fees
    ];

    // Apply currency format to Original Amount (10), Refunded Amount (11), Processing Fees (12)
    applyCurrencyFormat(XLSX, ws, sheetData, [10, 11, 12]);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Cancelled-Refunded Report');

    const filenameRange = buildFilenameRange(dateFrom, dateTo);
    writeWorkbookAndSave(XLSX, wb, `affiliate-cancelled-refunded-report-${filenameRange}.xlsx`);
};

export default exportAffiliateCancelledRefundedReportToXlsx;
